import React from "react";

const ActionPill = ({ text, textColor, bgColor }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${textColor} ${bgColor}`}>
    {text}
  </span>
);

export default ActionPill;
